<template>
  <transition name="slide-up">
    <div
      v-if="showBanner"
      class="fixed bottom-0 left-0 right-0 z-40 border-t border-white/10 bg-midnight-900/95 backdrop-blur px-6 py-4 shadow-glow"
    >
      <div class="mx-auto max-w-6xl">
        <div class="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div class="flex-1">
            <p class="text-sm font-semibold text-white">{{ $t('cookie.title') }}</p>
            <p class="mt-2 text-xs text-steel-300">
              {{ $t('cookie.description') }}
            </p>
          </div>
          <div class="flex flex-wrap gap-3 sm:flex-nowrap">
            <button
              type="button"
              class="rounded-2xl border border-white/10 bg-white/5 px-4 py-2 text-xs font-semibold uppercase tracking-[0.3em] text-white transition hover:border-white/30 hover:bg-white/10"
              @click="rejectCookies"
            >
              {{ $t('cookie.reject') }}
            </button>
            <button
              type="button"
              class="rounded-2xl bg-neon-400 px-4 py-2 text-xs font-semibold uppercase tracking-[0.3em] text-midnight-900 transition hover:bg-neon-300"
              @click="acceptCookies"
            >
              {{ $t('cookie.acceptAll') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
const runtimeEnv = typeof window !== 'undefined' ? window.__DRVN_ENV__ || {} : {}

export default {
  name: 'CookieConsent',
  data() {
    return {
      showBanner: false,
    }
  },
  mounted() {
    const cookieConsent = localStorage.getItem('drvn_cookie_consent')
    if (!cookieConsent) {
      this.showBanner = true
    } else if (cookieConsent === 'accepted') {
      // If consent was already given, load analytics
      this.loadGoogleAnalytics()
    }
  },
  methods: {
    setCookie(name, value, days = 365) {
      const date = new Date()
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
      const expires = `expires=${date.toUTCString()}`
      document.cookie = `${name}=${value};${expires};path=/;SameSite=Lax`
    },
    acceptCookies() {
      // Set cookie preference
      this.setCookie('cookie_consent', 'accepted')
      localStorage.setItem('drvn_cookie_consent', 'accepted')
      localStorage.setItem('drvn_cookie_timestamp', new Date().toISOString())
      
      // Load Google Analytics
      this.loadGoogleAnalytics()
      
      // Emit event for other components to listen
      this.$root.$emit('cookies-accepted')
      
      this.showBanner = false
    },
    rejectCookies() {
      // Set cookie preference
      this.setCookie('cookie_consent', 'rejected')
      localStorage.setItem('drvn_cookie_consent', 'rejected')
      localStorage.setItem('drvn_cookie_timestamp', new Date().toISOString())
      
      // Disable Google Analytics
      window['ga-disable-GA_MEASUREMENT_ID'] = true
      this.$root.$emit('cookies-rejected')
      
      this.showBanner = false
    },
    loadGoogleAnalytics() {
      const gaId = process.env.VUE_APP_GA_ID || runtimeEnv.VUE_APP_GA_ID
      
      if (!gaId) {
        console.warn('Google Analytics ID not configured. Set VUE_APP_GA_ID in your .env file')
        return
      }

      // Load Google Analytics script
      const script = document.createElement('script')
      script.async = true
      script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`
      document.head.appendChild(script)

      // Initialize gtag
      window.dataLayer = window.dataLayer || []
      function gtag() {
        window.dataLayer.push(arguments)
      }
      window.gtag = gtag
      gtag('js', new Date())
      gtag('config', gaId, {
        anonymize_ip: true,
        allow_google_signals: false,
      })
    },
  },
}
</script>

<style scoped>
.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.4s ease-in-out, opacity 0.4s ease-in-out;
}

.slide-up-enter-from {
  transform: translateY(100%);
  opacity: 0;
}

.slide-up-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
</style>

<style scoped>
.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.4s ease-in-out, opacity 0.4s ease-in-out;
}

.slide-up-enter-from {
  transform: translateY(100%);
  opacity: 0;
}

.slide-up-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
</style>
